import type {
  EffectiveFloorSystemOpeningFramingConfig,
  FloorSystemOpeningFramingConfig,
} from "building-types/floors/floorSystemOpeningFramingTypes";
import type { FloorOpeningFramingConfigGroup } from "building-types/framing/floorFramingTypes";
import type { ForeignEntityId } from "building-types/handles/foreignEntityId";

export const defaultFloorSystemOpeningFramingValues: Pick<
  EffectiveFloorSystemOpeningFramingConfig,
  "headerCount" | "trimmerCount" | "enableTailJoist"
> = {
  headerCount: 1,
  trimmerCount: 1,
  enableTailJoist: true,
};

export function resolveFloorSystemOpeningFramingConfig(
  config: FloorSystemOpeningFramingConfig | undefined,
  inheritedFramingComponentId: ForeignEntityId<"FRAMING_COMPONENT"> | undefined,
): EffectiveFloorSystemOpeningFramingConfig {
  return {
    headerCount: config?.headerCount ?? defaultFloorSystemOpeningFramingValues.headerCount,
    headerFramingComponentId: config?.headerFramingComponentId ?? inheritedFramingComponentId,
    trimmerCount: config?.trimmerCount ?? defaultFloorSystemOpeningFramingValues.trimmerCount,
    trimmerFramingComponentId: config?.trimmerFramingComponentId ?? inheritedFramingComponentId,
    enableTailJoist: config?.enableTailJoist ?? defaultFloorSystemOpeningFramingValues.enableTailJoist,
    tailJoistFramingComponentId: config?.tailJoistFramingComponentId ?? inheritedFramingComponentId,
  };
}

export function floorSystemOpeningFramingConfigToInputGroup(
  config: FloorSystemOpeningFramingConfig | undefined,
  inheritedFramingComponentId: ForeignEntityId<"FRAMING_COMPONENT"> | undefined,
): FloorOpeningFramingConfigGroup {
  const effectiveConfig = resolveFloorSystemOpeningFramingConfig(config, inheritedFramingComponentId);

  return {
    headerConfig: {
      count: effectiveConfig.headerCount,
      ...(effectiveConfig.headerFramingComponentId
        ? { framingComponentId: effectiveConfig.headerFramingComponentId }
        : {}),
    },
    trimmerConfig: {
      count: effectiveConfig.trimmerCount,
      ...(effectiveConfig.trimmerFramingComponentId
        ? { framingComponentId: effectiveConfig.trimmerFramingComponentId }
        : {}),
    },
    tailJoistConfig: {
      disabled: !effectiveConfig.enableTailJoist,
      ...(effectiveConfig.tailJoistFramingComponentId
        ? { framingComponentId: effectiveConfig.tailJoistFramingComponentId }
        : {}),
    },
  };
}
